/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

// @helpers
import routesConfig from "../../../config/routes.config";
import { formatPrice, optionsCancelService } from "../../../helpers/functionsUtils";

// @store
import useProfileStore from "../../../store/useProfileStore";
import { useSpinnerStore } from "../../../store/useSpinnerStore";
import useServiceStore from "../../../store/useServiceStore";
import useProposalStore from "../../../store/useProposalStore";

// @components
import ModalDelet from '../../../components/Modals/modalDelete/ModalDelete';
import Modal from "../../../components/Modals/Modal";

// @types
import { ServiceRequestStatus } from "../../../types/enums.types";

const DetailService = () => {
  const location = useLocation();
  const { openSpinner } = useSpinnerStore();
  const { service } = location.state;
  const { updateStatus } = useServiceStore();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { professional, getProfessionalInfo, isLoading } = useProfileStore();
  const [openModal, setOpenModal] = useState(false);
  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const { fetchProposalsByRequest, data } = useProposalStore();
  const [optionToCancel, setOptionToCancel] = useState('');
  const [noOptionSelected, setNoOptionSelected] = useState('');

  const closeModal = () => setOpenModal(!openModal);

  useEffect(() => {
    if (isLoading) return openSpinner(true);
    return openSpinner(false);
  }, [isLoading])

  const handleProposalValue = async () => {
    openSpinner(true);
    const status = service.serviceRequestStatus === 1 || service.serviceRequestStatus === 6 ? 0 : service.serviceRequestStatus === 2 ? 2 : 3;
    try {
      await fetchProposalsByRequest(service.serviceRequestId, status);
      openSpinner(false);
    } catch (error) {
      openSpinner(false);
      toast.error(t("error.callList"));
    }
  };

  useEffect(() => {
    handleProposalValue();
    if (service?.professionalId) getProfessionalInfo(service?.professionalId);
  }, [service]);

  const cancelServiceByUser = () => {
    if (!optionToCancel) return setNoOptionSelected(t("myServices.service.error"));
    handleCancelService();
  }

  const handleCancelService = async () => {
    openSpinner(true);
    try {
      await updateStatus(service?.serviceRequestId, ServiceRequestStatus.pendingCancellation, optionToCancel);
      openSpinner(false);
      setOpenModalConfirm(!openModalConfirm);
      setOptionToCancel('');
      onBack();
    } catch (error) {
      openSpinner(false);
      toast.error(t("error.errorDelete"))
    }
  };

  const onBack = () => navigate(routesConfig.myServices)

  const renderValue = (title: string, value: string) => {
    return (
      <div className="w-full flex flex-col gap-[10px] mb-[20px]">
        <h6 className="w-full text-[#3A3A3A] dark:text-white/80 text-[13px] font-medium">
          {title}
        </h6 >
        <p className="w-full text-[#A1A1A1] text-[13px] font-normal border border-[#B8B8B8] rounded-md flex px-[10px] py-[8px]">
          {value}
        </p>
      </div>
    )
  }

  const renderHistoryProfessional = () => {
    if (professional?.history && professional?.history.length > 100) return `${professional?.history.slice(0, 100)}...`;
    return professional?.history;
  }

  const closeModalConfirm = () => {
    setOpenModalConfirm(!openModalConfirm);
    setOpenModal(!openModal);
  }

  return (
    <section className="w-full m-auto  p-[20px]">
      <button
        onClick={onBack}
        className="flex items-center gap-2 mb-[10px] text-cTextSecondary dark:text-white/70 hover:text-cPrimary"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 19.5L8.25 12l7.5-7.5" />
        </svg>
        {t("myServices.service.backText")}
      </button>

      <div className="w-full flex flex-col bg-cBackground dark:bg-dark-cBackgroundSecondary rounded-lg py-3">
        <h5 className="w-full text-[#181725] dark:text-white text-[15px] font-medium mb-[10px]">
          {t("myServices.service.title")}{service.category.name}
        </h5>

        <div className="w-full flex flex-col lg:flex-row gap-[10px] lg:gap-[40px] mb-[30px]">
          <img
            src={service.category.urlImage}
            alt={service.category.name}
            className="w-full h-48 rounded-lg object-cover"
          />

          <div className="w-full rounded-md bg-[#F97068] flex flex-col items-center justify-between py-[10px] px-[20px] h-48">
            <h5 className="w-full text-white text-[20px] font-semibold flex justify-center">
              {t("myServices.service.service")} {service?.serviceRequestNumber}
            </h5>

            <div className="w-full flex gap-[10px]">
              <img
                //src={"/assets/img/hand.png"}
                src={professional?.companyImage || `https://eu.ui-avatars.com/api/?name=${professional?.name || 'User'}+${professional?.lastNames || ''}&size=200`}
                alt="background for company"
                className="w-20 h-20 rounded-[100%] object-cover mb-[30px] bg-white"
              />

              <div className="flex flex-col gap-[5px]">
                <h5 className="w-full text-white text-[20px] font-semibold">
                  {professional?.name ?? ''}
                </h5>

                <p className="w-full text-white text-[14px] font-normal">
                  {renderHistoryProfessional()}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full flex flex-col lg:flex-row gap-[10px] lg:gap-[40px]">
          <div className="w-full rounded-md">

            <div className="w-full flex flex-col gap-[10px] mb-[20px]">
              <h6 className="w-full text-[#3A3A3A] dark:text-white/80 text-[13px] font-medium">
                {t("myServices.service.yourService")}
              </h6 >
              {
                service?.services?.map((item: { name: string }) => (
                  <p key={item.name} className="w-full text-[#A1A1A1] text-[13px] font-normal border border-[#B8B8B8] rounded-md flex px-[10px] py-[8px]">
                    {item.name}
                  </p>
                ))
              }
            </div>

            {renderValue(t("myServices.service.yourRequest"), service?.description)}
          </div>

          <div className="w-full rounded-md">
            {renderValue(t("myServices.service.requestDate"), (new Date(service.createdAt).toLocaleDateString()))}
            {renderValue(t("myServices.service.requestNumber"), service?.serviceRequestNumber)}
            {renderValue(t("myServices.service.price"), formatPrice(data?.items[0]?.proposalValue ?? 0))}
          </div>
        </div>
      </div>

      {service?.serviceRequestStatus === 1 && (
        <div className="mt-6 w-full flex justify-center">
          <button
            onClick={closeModal}
            className="bg-[#F97068] text-white px-[5vw] py-2 rounded-lg hover:bg-red-600 disabled:opacity-50"
          >
            {t("myServices.service.textButton")}
          </button>
        </div>
      )}

      <ModalDelet
        open={openModal}
        close={closeModal}
        title={t("myServices.service.textDelete")}
        submit={closeModalConfirm}
      />

      <Modal
        isOpen={openModalConfirm}
        onClose={closeModalConfirm}
        title=""
        hasButtonClose={false}
      >
        <div className="min-h-[200px] max-w-[600px] flex flex-col items-center gap-[20px]">
          <div className="flex flex-col gap-1">

            <label className="text-cTextSecondary dark:text-dark-cTextSecondary my-6">
              {t("myServices.service.titleModalCancel")}
            </label>

            <div className="flex flex-col gap-2">
              <select
                value={optionToCancel}
                onChange={(e) => {
                  setOptionToCancel(e.target.value);
                  setNoOptionSelected('');
                }}
                className="w-full py-2 border-b text-cTextSecondary/50 dark:text-dark-cTextSecondary/50 placeholder:text-cTextSecondary/50 dark:placeholder-dark-cTextSecondary/50 focus:outline-none focus:ring-0"
              >
                <option className="text-[12px]" value="">
                  {t("myServices.service.selectOption")}
                </option>
                {optionsCancelService.map((option) => (
                  <option
                    className=" w-full truncate text-[12px]"
                    key={option}
                    value={option}
                  >
                    {option}
                  </option>
                ))}
              </select>
              {noOptionSelected &&
                <span className="text-[#FC0000] text-[13px] ">
                  {noOptionSelected}
                </span>
              }
            </div>
          </div>
          <button
            onClick={cancelServiceByUser}
            className="bg-[#F97068] text-white px-4 py-2 rounded-lg w-[200px]"
          >
            {t("professional.acceptButton")}
          </button>
        </div>
      </Modal>
    </section>
  );
};

export default DetailService;
